import { MmmModelOutput } from '../mmmModelOutput';
import {
  AxisChartByString,
  ChartByStringBarScatter
} from 'features/charts/chart.models';
import { createmodelledRoiteByChannelChart } from './modelled-roi-by-channel-chart';
import { createmodelledRoiGroupedChart } from './modelled-roi-grouped-chart';

export const createModelledRoiCharts = (
  ddaResponse: MmmModelOutput
): ModelledRoiCharts => {
  const chart: ModelledRoiCharts = {
    modelledRoiByChannel: createmodelledRoiteByChannelChart(ddaResponse),
    modelledRoiGrouped: createmodelledRoiGroupedChart(ddaResponse)
  };

  return chart;
};

export interface ModelledRoiCharts {
  modelledRoiByChannel: ChartByStringBarScatter;
  modelledRoiGrouped: AxisChartByString;
}
